export enum SaleType {
  Acquisition = 'Acquisition',
  Renewal = 'Renewal',
}
